exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".event{padding:0!important}#bx{position:relative;-webkit-animation:mymove 1s 1;animation:mymove 1.5s 1}@keyframes mymove{0%{right:-230px;-webkit-filter:brightness(70%);filter:brightness(70%)}to{right:0;-webkit-filter:brightness(100%);filter:brightness(100%)}}@-webkit-keyframes mymove{0%{right:-230px;-webkit-filter:brightness(80%);filter:brightness(80%)}to{right:0;-webkit-filter:brightness(100%);filter:brightness(100%)}}", ""]);

// exports
